module.exports = __webpack_public_path__ + "static/img/face_3.cbb5925c.webp";